import React from "react";
import { DownOutlined, RightOutlined } from "@ant-design/icons";
import LoadingSpinner from "../Loading";
import { useTranslation } from "react-i18next";

const AccessRightsTable = ({
    menuData,
    permissions,
    expandedMenus,
    toggleMenu,
    handlePermissionChange,
    loading,
}) => {
    const { t } = useTranslation();

    if (loading) {
        return <LoadingSpinner />;
    }

    // --- Helpers ---
    const isChecked = (key, type) =>
        permissions[key] ? permissions[key][type] || false : false;

    return (
        <table className="w-full border-collapse">
            <thead>
                <tr className="bg-[#78CFEC66] text-left">
                    <th className="p-3 text-gray-700 font-semibold">{t("Menu / Sub-Menu")}</th>
                    <th className="p-3 text-gray-700 font-semibold text-center">{t("View")}</th>
                    <th className="p-3 text-gray-700 font-semibold text-center">{t("Edit")}</th>
                </tr>
            </thead>
            <tbody>
                {menuData.map((menu) => {
                    const parentKey = `menu_${menu.parent_menu_id}`;
                    const isEditChecked = isChecked(parentKey, "edit"); // ✅ track edit status

                    return (
                        <React.Fragment key={menu.parent_menu_id}>
                            {/* Parent Menu Row */}
                            <tr
                                className="cursor-pointer font-normal border bg-white hover:bg-gray-100"
                                onClick={() =>
                                    menu.sub_menu_list?.length > 0 &&
                                    toggleMenu(menu.parent_menu_id)
                                }
                            >
                                <td className="p-3 text-gray-800 flex items-center gap-2">
                                    {menu.sub_menu_list?.length > 0 &&
                                        (expandedMenus.includes(menu.parent_menu_id) ? (
                                            <DownOutlined className="text-xs" />
                                        ) : (
                                            <RightOutlined className="text-xs" />
                                        ))}
                                    {menu.name}
                                </td>

                                {/* Parent Read */}
                                <td className="p-3 text-center">
                                    <input
                                        type="checkbox"
                                        checked={isChecked(parentKey, "read")}
                                        disabled={isEditChecked || menu.name === "E-Orders" || menu.name === "الطلبات الإلكترونية"} //  disable when edit is checked
                                        onChange={(e) => {
                                            e.stopPropagation();
                                            handlePermissionChange(
                                                parentKey,
                                                "read",
                                                e.target.checked,
                                                menu.sub_menu_list
                                            );
                                        }}
                                    />
                                </td>

                                {/* Parent Edit */}
                                <td className="p-3 text-center">
                                    <input
                                        type="checkbox"
                                        checked={isEditChecked}
                                        onChange={(e) => {
                                            e.stopPropagation();
                                            handlePermissionChange(
                                                parentKey,
                                                "edit",
                                                e.target.checked,
                                                menu.sub_menu_list
                                            );
                                        }}
                                    />
                                </td>
                            </tr>

                            {/* Submenus */}
                            {expandedMenus.includes(menu.parent_menu_id) &&
                                menu.sub_menu_list?.map((submenu) => {
                                    const subKey = `submenu_${submenu.sub_menu_id}`;
                                    const isSubEditChecked = isChecked(subKey, "edit"); // track submenu edit
                                    return (
                                        <tr key={submenu.sub_menu_id} className="bg-white">
                                            <td className="p-3 ps-8 font-normal text-gray-600">
                                                • {submenu.name}
                                            </td>
                                            <td className="p-3 text-center">
                                                <input
                                                    type="checkbox"
                                                    checked={isChecked(subKey, "read")}
                                                    disabled={isSubEditChecked || submenu.name === "View Orders" || submenu.name === "عرض الطلبات"} // disable when edit checked
                                                    onChange={(e) =>
                                                        handlePermissionChange(
                                                            subKey,
                                                            "read",
                                                            e.target.checked
                                                        )
                                                    }
                                                />
                                            </td>
                                            <td className="p-3 text-center">
                                                <input
                                                    type="checkbox"
                                                    checked={isSubEditChecked}
                                                    onChange={(e) =>
                                                        handlePermissionChange(
                                                            subKey,
                                                            "edit",
                                                            e.target.checked
                                                        )
                                                    }
                                                />
                                            </td>
                                        </tr>
                                    );
                                })}
                        </React.Fragment>
                    );
                })}
            </tbody>
        </table>
    );
};

export default AccessRightsTable;
